import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const CadenaFlagPanel = () => {
  const [enabled, setEnabled] = useState(null);

  useEffect(() => {
    api.get("/admin/cadena/flag").then((r) => setEnabled(r.data.enabled)).catch(() => toast.error("No pudimos cargar el interruptor"));
  }, []);

  async function update(v) {
    try {
      const r = await api.put("/admin/cadena/flag", { enabled: v });
      setEnabled(r.data.enabled);
      toast.success("Interruptor actualizado");
    } catch {
      toast.error("No pudimos guardar el cambio");
    }
  }

  if (enabled === null) return null;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 mt-6" data-testid="admin-cadena-flag-panel">
      <label className="flex items-center justify-between gap-4">
        <span>
          <span className="block font-display text-lg font-bold text-slate-900">Cadena del talento</span>
          <span className="block text-sm text-slate-500">Sustituye al radar en los resultados, la comparativa y el PDF del diagnóstico rápido. Apagado: todo se ve como siempre.</span>
        </span>
        <Switch checked={enabled} onCheckedChange={update} data-testid="admin-cadena-flag" />
      </label>
    </div>
  );
};
